import React from "react";
import { useAppSelector } from "src/redux/hooks";

const TenantDetailsCard: React.FC = () => {
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authTenant);

  console.log(user);

  return (
    <div>
      <div>
        <div>
          <span className="font-semibold">Company Name:</span>{" "}
          {user?.tenantDetails?.name}
        </div>
      </div>

      <div>
        <div>
          <span className="font-semibold">Company Email:</span>{" "}
          {user?.tenantDetails?.email}
        </div>
      </div>
    </div>
  );
};

export default TenantDetailsCard;
